<div class="main-container">
  <div class="verification-content verification-title">
    <h1 appConfigSettingsTitle appConfigSettingsBackground>
      {{ "IdinVerificationFailedPage.Title" | translate }}
    </h1>
  </div>
  <mat-divider></mat-divider>
  <div class="verification-content-failure" appConfigSettingsParagraph>
    <p>
      {{ "IdinVerificationFailedPage.FailedMessage" | translate }}
    </p>
  </div>
  <mat-divider></mat-divider>
</div>
